<template>
  <div class="px-3 overflow-auto">
    <h4>Instructions</h4>
    <ol>
      <li>
        <a
          class="btn btn-tertiary bg-tertiary text-white"
          href="/assets/file_template/BulkLocationAddTemplate.csv"
          download
          ><i class="fa fa-download mr-2"></i>Download Bulk Location Template</a
        >
      </li>
      <li>
        Add your data to the template. You may use your own CSV file with
        additional fields. However, it must contain columns with these exact
        names.
        <ul>
          <li><b>Name</b> - Minimum 5 characters, max of 100 characters.</li>
          <li>
            <b>Latitude</b> - Number between ±90 and up to 7 digits after the
            decimal. This is a 10 cm resolution.
          </li>
          <li>
            <b>Longitude</b> - Number between ±180 and up to 7 digits after the
            decimal. This is a 10 cm resolution.
          </li>
        </ul>
      </li>

      <li>
        <label for="csvFile" class="btn btn-tertiary mb-0">
          <i class="fa fa-upload mr-2"></i>Upload CSV
          <input
            ref="csvRef"
            type="file"
            id="csvFile"
            accept=".csv"
            :key="csvFileKey"
            @input="(event) => inputFile(event)"
            style="display: none"
          />
        </label>
      </li>
    </ol>
    <div v-if="bulkUploadError" class="alert alert-danger">
      {{ bulkUploadError }}
    </div>
    <div class="btn btn-secondary" @click="$emit('close')">
      <i class="fa fa-close mr-2"></i>Cancel
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";

export default {
  name: "BulkLocations",
  data() {
    return {
      bulkUploadError: null,
      csvFileKey: 0,
    };
  },
  props: {
    lastLocationKey: {
      type: Number,
      required: true
    },
  },
  methods: {
    inputFile(event) {
      if (
        !event ||
        !event.target ||
        !event.target.files ||
        !event.target.files[0]
      ) {
        return;
      }
      const file = event.target.files[0];
      const config = {
        header: true,
        skipEmptyLines: true,
        complete: this.papaComplete,
      };
      Papa.parse(file, config);
      this.csvFileKey++;
    },
    papaComplete(papaOutput) {
      //console.log(papaOutput);
      this.bulkUploadError = null;
      if (!papaOutput.meta.fields) {
        // check to make sure columns are valid
        this.bulkUploadError = "No header columns found in CSV file";
        return;
      }
      if (!papaOutput.meta.fields.includes("Name")) {
        this.bulkUploadError = "The 'Name' column was not found";
        return;
      }
      if (!papaOutput.meta.fields.includes("Latitude")) {
        this.bulkUploadError = "The 'Latitude' column was not found";
        return;
      }
      if (!papaOutput.meta.fields.includes("Longitude")) {
        this.bulkUploadError = "The 'Longitude' column was not found";
        return;
      }
      if (papaOutput.data.length === 0) {
        this.bulkUploadError = "No locations rows found in the CSV file";
        return;
      }
      const firstLocationKey = 1 + this.lastLocationKey;
      const papaLocations = papaOutput.data.map((papaRow, index) => {
        return {
          name: papaRow.Name,
          lngLat: {
            lat: parseFloat(papaRow["Latitude"]).toFixed(7),
            lng: parseFloat(papaRow["Longitude"]).toFixed(7),
          },
          key: index + firstLocationKey,
          isSaving: false,
          "@id": null,
          error: null,
        };
      });
      this.$emit('addLocations',papaLocations)
    },
  },
};
</script>
<style scoped></style>
